import { classes } from '../const';

const { isVisible } = classes;

const gridCards = () => {
    let popupOpen = false;

    $(window).scroll(function () {
        const gridCardsElem = document.querySelector('.grid-cards');
        if (gridCardsElem) {
            const visibleCard = gridCardsElem.querySelector('.is-visible .popup-card');
            if (visibleCard) {
                const offsetTop = gridCardsElem.getBoundingClientRect().top - 80;
                const offsetBottom = gridCardsElem.getBoundingClientRect().bottom - visibleCard.getBoundingClientRect().height - 80;
                if (offsetBottom > 0 && offsetTop < 0) {
                    gridCardsElem.classList.add('in-viewport');
                    gridCardsElem.classList.remove('above-viewport');
                    gridCardsElem.classList.remove('below-viewport');
                }
                else if (offsetBottom > 0 && offsetTop > 0) {
                    gridCardsElem.classList.add('above-viewport');
                    gridCardsElem.classList.remove('below-viewport');
                    gridCardsElem.classList.remove('in-viewport');
                }
                else if (offsetBottom < 0 && offsetTop < 0) {
                    gridCardsElem.classList.add('below-viewport');
                    gridCardsElem.classList.remove('above-viewport');
                    gridCardsElem.classList.remove('in-viewport');
                }
            }
        }
    });

    $('.grid-cards .grid-cards-items').hover(function () {
        $(this).css({ 'transform': 'translate(0px,-5px)' });
    }, function () {
        $(this).css({ 'transform': 'matrix(1, 0, 0, 1, 0, 0)' });
    });


    $('.grid-cards .grid-cards-items:not(.grid-cards-no-popup)').click(function (e) {
        if (!popupOpen) {
            $(this).next('.popup-card-wrapper').addClass(isVisible);
            $(this).css({ 'opacity': '0.1', 'cursor': 'default' });
            $(this).siblings('.grid-cards .grid-cards-items').css({ 'opacity': '0.1', 'cursor': 'default' });
            // trigger scroll event
            $(window).scrollTop($(window).scrollTop()+1);
            popupOpen = true;
        }
    });
    $('.grid-cards .grid-cards-items:not(.grid-cards-no-popup) .cards-link').click(function (e) {
        if (!popupOpen) {
            $(this).parent().next('.popup-card-wrapper').addClass(isVisible);
            $(this).parent().css({ 'opacity': '0.1', 'cursor': 'default' });
            $(this).parent().siblings('.grid-cards .grid-cards-items').css({ 'opacity': '0.1', 'cursor': 'default' });
            // trigger scroll event
            $(window).scrollTop($(window).scrollTop()+1);
            popupOpen = true;
        }
    });
    $('.grid-cards .close-icon').click(function (e) {
        if (popupOpen) {
            $(this).parent().parent().removeClass(isVisible);
            $(this).parent().parent().siblings('.grid-cards .grid-cards-items').css({ 'opacity': '1', 'cursor': 'pointer' });
            $(this).parent().parent().css({ 'opacity': '1', 'cursor': 'pointer' });
            // trigger scroll event
            $(window).scrollTop($(window).scrollTop()+1);
            popupOpen = false;
        }
    });
};

export default gridCards;